import type { CourseInfoType } from "../../utils/types";
export const CourseInfo: CourseInfoType = [
  
  {
    categoryID: "omron",
    categoryDescription: "雪花燈PCB焊接X機械人建設體驗",
    courses: [
      {
        courseName: "Omron Team Building",
        courseID: "Workshop001",
        description: "雪花燈PCB焊接X機械人建設體驗",
        categoryID: "omron",
        image:
          "https://i.imgur.com/g6zJVtg_d.webp?maxwidth=1520&fidelity=grand",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "雪花燈PCB焊接",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EtfhphvllTBJiRd2jM258-UBxT0eFYcbL6rRkES8rtYkew?e=n2LYLN",
          },
          {
            topic: "機械人建設體驗",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ehf4Ikh1odNIniONauGLipgBpTJJOMO9pPDX8rfccziOiw?e=kt5A76",
          },
        ],
      },
    ],
  },

  {
    categoryID: "PCB",
    categoryDescription:
      "無論是顯示器，平板電腦還是智能手機，都是硬件。 我們社會所有現有技術的皆由硬件支撐。通過物理和電子知識的各種組合，我們可以創造出從日常生活、科學研究、能量采集到硬件加速等任何方面來幫助人類的設備",
    courses: [
      {
        courseName: "EasyEDA 入門課程",
        courseID: "PCB01",
        description:
          "EasyEDA是一個網頁工具，讓使用者在不需要專業知識和撰寫程式碼的情況下，能簡單地進行原理圖繪製, 印刷電路板元器件放置及設計功能。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/EjfsSIr.png",
        resources: [          
        {
          topic: "PCB設計",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/Eo5uHeHkMD9DtjmefrQccbsBO0LpJzl2UviyxMZy81i8qA?e=L2t61g",
        },
        {
          topic: "註冊EasyEDA帳號",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EuAvB6VQOkJEhYi3pGjWiaEB_swil45-_LHeK7FqfuiKnA?e=W00hJo",
        },
      ],
      },
      {
        courseName: "復活蛋閃爍電路",
        courseID: "PCB01.1",
        description:
          "學習以鈕扣電池驅動一個可以令LED閃爍的非穩態多諧振盪器(Astable Multivibrator)電路，並在電路板上加入復活蛋元素的設計，開始成為微電子工程師的第一步。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/8nM8F2J.jpeg",
        resources: [          
        {
          topic: "PCB設計",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/Em5J41v5WKhIpNphLJYDB5IBXe6IjUmZEbMrIYXL5ohBTg?e=1amcez",
        },
        {
          topic: "焊接教學",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EpE88Wb6bu1DpOb_KZaFhWUB9Ct__yoVb6w2TQBB5C_ZLw?e=SoyJpd",
        },
      ],
      },

      {
        courseName: "NFC個人卡片",
        courseID: "PCB01.2",
        description:
          "對卡片燒錄個人資料,如姓名、電話號碼。當其他NFC裝置掃過時可以將資料自動輸入。也可設定網址,掃過時自動導向網站。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/gNL8pEW.jpeg",
        resources: [          
        {
          topic: "PCB設計",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EsyBq7hobnFIr5l0lv6RoeUBEGWj7dCJkrlQB52wG2Wsjw?e=2O1gyo",
        },
        {
          topic: "焊接教學",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EvX4j0lqjgZAjNMYf6b0dfMBrn7scxaaRn3cii1bvHHbGg?e=mZGMcl",
        },
      
      ],
      },
      {
        courseName: "LED燈箱",
        courseID: "PCB01.3",
        description:
          "使用USB供電給LED背板令到面板上的圖案發光。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/hTBrSRn.jpeg",
        resources: [          
        {
          topic: "PCB設計",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EvcdYtyeUGNFhux0kXzLDJMBU_KTCsiM_fnCdKvE-0kTig?e=jOPh4u",
        },
        {
          topic: "焊接教學",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EvvAUWjvOplNkKxWNoZyItsBpgAkjlN9lN9KCB1uTTWE8A?e=X5V22Q",
        },
        {
          topic: "PCB蝕刻教學",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:p:/g/ERA9XXYrsQ5EqTlBOppyarsBRqOSE8VNbtLgMLGkkzk-Zg?e=fXGrQ9",
        },
      ],
      },

      {
        courseName: "MP3播放器",
        courseID: "PCB01.4",
        description:
          "對播放器燒錄MP3音頻檔，並且使用按鈕或者傳感器去觸發音效，并基於這個進行基礎物聯網設備開發",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/y52Ciza.jpeg",
        resources: [          
          {
            topic: "PCB設計",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EgSyc3wuEdtKveZ3NY5ArJABVb0i8-e0YTVD0S-1fgNTrw?e=Ca9XpG",
          },
          {
            topic: "焊接教學",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EtU4M0OG4SFCrmI26-C0WZsB1jh6FcPo3pdWP7xJcqkTkQ?e=eOwe7N",
          },],
      },

      {
        courseName: "電容感應桌燈",
        courseID: "PCB01.5",
        description:
          "使用USB供電給LED流水燈，利用電容感應芯片檢測使用者是否觸碰PCB，以此更改流水燈的模式。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/c2mFcYh.jpg",
        resources: [          
          {
            topic: "PCB設計",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ekj3pgXTW49IonliJZVOPM4BOrfN-yMsDzOb9gDw19gFzg?e=ZbD1p1",
          },
          {
            topic: "焊接教學",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Eu-jiWxCW39Nsly_QdbeD6oBaC5UftHjtEiNXs7tdaf5Pw?e=9l5FLW",
          },],
      },

      {
        courseName: "Microbit擴充板",
        courseID: "PCB01.6",
        description:
          "使用鋰電池供電給Microbit，並使用擴充板上各種功能，例如RGB LED, 馬達驅動, 温濕度傳感器。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/hQpOL2L.jpeg",
        resources: [          
        {
          topic: "PCB設計",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EqRotht9SIBCh3Ww7WtHYLgBFgvVIFVN71SUY6Rp6GbkQw?e=9aPEyZ",
        },
        {
          topic: "焊接教學",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/Evb7oqvmIE5As09EEzlnwxwBkpc5jy7_gnOVojhJd2TEqQ?e=WWhPn7",
        },
      ],
      },

      {
        courseName: "PCB&AI",
        courseID: "PCB01.7",
        description:
          "設計自己的電路板去整合傳感器AI芯片,通訊模組,並製作3D外殼以建立屬於自己的語音無線遙控器",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/DkTXZtg.png",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "Lesson01 PCB電路設計",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ek-Okwi_ioNDn80JFuMwm1YB9uX_hHJ1hQejkuBz4ZMS9A?e=KfsEXe",
          },
          {
            topic: "Lesson02 PCB布版設計",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EtVNzsOQmM1OtstEbn__afEBi17YB0J94BqEZzsP87SWog?e=QVJJxq",
          },
          {
            topic: "Lesson03 語音AI",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Engs5lHUN8ZDk0gVbkrehNEBhZMI01qXtIZRiowaaIQ5gg?e=fAzd93",
          },
          {
            topic: "Lesson04 設計思維與3D設計",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EuaQRDpVr_hHntqqamM9NVIBcE-pUXEfssif4cmusAn-bA?e=hmXEif",
          },
          {
            topic: "Lesson05 焊接，組裝，設計(1)",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EgAUlb9KbjZCuIBgLRhVbL0Bw4b5Hzcu0Z0GjZ1kUz2Bgw?e=yLvZAu",
          },
          {
            topic: "Lesson06 焊接，組裝，設計(2)",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EiZ5uDOZHh1AksNWNQk95F8B6FvoP9C8TDxmS5zHpkepqg?e=xrRPqQ",
          },
          {
            topic: "Lesson7 賽前測試",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EuKPVazogatNiTk_ceZSwrABQ8xKY8AVJmNQXd0V5Jm68Q?e=xieZHR",
          },
          {
            topic: "Lesson8 比賽環節",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Et1kP4cV25xIhhZDtDcY7yEBqTCqAC3g-3PfF3fBeaHkQA?e=rvLfUv",
          },
        ]
      },

      {
        courseName: "智慧天文台",
        courseID: "PCB01.8",
        description:
          "用電腦軟體進行設計，並實際製作出屬於自已的智慧天文台裝置。智慧天文台系統能提供天氣和環境資訊，同學們可以藉此進一步分析和視覺化數據，如風向、紫外線強度、空氣質素等，並應用在日常生活中。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/jQ4mtmH.png",
        resources: [          
        {
          topic: "PCB設計",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EjNzIaUmYzVKmg17JSl1lSMB0nBF3tdoW7rsCCpHFdNF6Q?e=4v8Zoi",
        },
        {
          topic: "天文台RS485通信及MCU編程",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EhC_F5AuRJRKgRAONuwReukB0J1OSZOzxNtZwIImeVCBxg?e=rcaS9k", 
        },
        {
          topic: "焊接教學",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/Ev8aedo1JFxOkglW2bkIgXUBAihIjCVFgYJzDfhuHK5zww?e=19RAZj", 
        },
      ],
      },

      {
        courseName: "無綫行動電源",
        courseID: "PCB01.9",
        description:
          "但可以使用常規的USB線進行充放電，更可以利用無綫充電芯片檢測兼容無線充電的行動裝置，進行快速無綫充電。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/J1QdzEy.jpeg",
        resources: [          
        {
          topic: "焊接教學",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EhludtBcCq5HpPCoEYHiI4QBRJsY9fE8Kvm6XCWyoj70MQ?e=xPVonu",
        },],
      },

      {
        courseName: "Pong Game掌上遊戲機",
        courseID: "PCB01.10",
        description:
          "可以使用按鈕遊玩燒錄在ESP32內的世界上第一款電子遊戲: Pong Game",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/ulefhk4.jpeg",
        resources: [          
        // {
        //   topic: "Pong Game掌上遊戲機",
        //   downloadUrl:
        //     "https://stemturnede.sharepoint.com/:f:/g/Ek9bXZMMgBRDj2ttMmr_bbIBzP4jaPA99VrsQaPtuhpsaw?e=4s0gHZ",
        // },
      
      ],
      },

      {
        courseName: "應援棒設計課程",
        courseID: "PCB01.11",
        description:
          "整個作品分為四大部份，電路板設計，中控介面設計，3D外殼設計，用戶手冊編寫 ",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/CNSWNHa.png",
        resources: [          
        // {
        //   topic: "應援棒5小時工作坊",
        //   downloadUrl:
        //     "https://stemturnede.sharepoint.com/:f:/g/ElOlCqKTLR1IsKtXASwFiiQBGA6cBwuHICKGs_yy2pyD9A?e=A4qXmm",
        // },
      
      
      ],
        
      },
      {
        courseName: "Microbit X PCB 簡易入門課程",
        courseID: "PCB01.12",
        description:
          "通過15小時的課程，同學學習使用micro:bit， 由0開始製作智能家居語音溫濕度傳感器專題。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/CNSWNHa.png",
        resources: [          
        {
          topic: " Lesson 1-3 Microbit 智能家居語音溫濕度傳感器",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EtjveCJa4m9Jo2ivs7olQnMBmuwkPQlhMZnv86RfsejOWw?e=9d82pD",
        },
        {
          topic: " Lesson 4-9 PCB設計",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EsaP1zwOcOdEhyfQc1oov9kBxlMmm5PNyp1QdcGJ_NVRnQ?e=XhjE4m",
        },
        {
          topic: " Lesson 10-14 焊接教學",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/Em7qT4k3wUtDn6e6G_Zx63ABbJraZjRH7EVhCh4uLhZJeg?e=BDaSdA",
        },
        {
          topic: " 習作遞交",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/Es7rf8Lpy9xFuQQuYw9DF3wBuh6VUdAfG1Bu10SbAKqTIQ?e=c7Ohbn",
        },
      
      ],
        
      },

      {
        courseName: "電子工程基礎課程",
        courseID: "PCB02",
        description:
          "會透過基礎電路製作，PCB電路板作品製作及焊接教學，掌握微電子及電路學的基礎知識，並進一步透過學習使用藍牙等芯片製作智慧作品，認識微電子科技的應用！ 此外本課堂另外設有最終作品項目,給學生運用課堂知識,以工業4.0及綠色電機為題以小組為單位創作作品。",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/CNSWNHa.png",
        resources: [          
        // {
        //   topic: "電子工程基礎課程",
        //   downloadUrl:
        //     "https://stemturnede.sharepoint.com/:f:/g/Et0Bt79yi6ZOvK4D0Jt5AEgB4_v34YKlCyP2hLu6nbR-9w?e=ahHGvN",
        // },
      
      ],
      },

      {
        courseName: "PCB蝕刻課程 ",
        courseID: "PCB03",
        description:
          "體驗使用化學溶液進行PCB蝕刻",
        categoryID: "PCB",
        image:
          "https://i.imgur.com/CNSWNHa.png",
        resources: [          
        // {
        //   topic: "PCB蝕刻課程 ",
        //   downloadUrl:
        //     "https://stemturnede.sharepoint.com/:f:/g/EmGrfJOIvfFAts2buv_tfwIBKi1Wp8eB-uAMIzeLkAXnUQ?e=b9Zybr",
        // },
      
      
      ],
      },

    ]
    
  },

  {
    categoryID: "PCB Competition",
    categoryDescription: "Semtron PCB Competition",
    courses: [
      {
        courseName: "Semtron PCB Competition 2023",
        courseID: "SPC2023",
        description: "Semtron PCB Competition 2023",
        categoryID: "PCB Competition",
        image:
          "https://i.imgur.com/g6zJVtg_d.webp?maxwidth=1520&fidelity=grand",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "比賽工作坊",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EkM0NVWQYFBItvjXv6wuSgUBGK6kZtXh5IGdSF4ZaFCJtQ?e=kvvLrR",
          },
          {
            topic: "工具教學及設計Tips",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EqU05ASNB2pMqg9BlhT6JV0BC1_T37qLaOd6GBOP9p2wMQ?e=X7jZEU",
          },
          {
            topic: "範例文件",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EgS0pIjpezpHjYZ3_LbB_QEBrOwnJumuW86NsRKLDUvR-w?e=Wdlg99",
          },
        ],
      },
      {
        courseName: "Semtron PCB Competition 2024",
        courseID: "SPC2024",
        description: "Semtron PCB Competition 2024",
        categoryID: "PCB Competition",
        image:
          "https://i.imgur.com/thSUKmD.png",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "比賽工作坊",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EmzGHiXVG0NDnqr6_Wg2av8BtCOWNiJemZ1D1ys2TnWabQ?e=uZ82sz",
          },
        ],
      }
    ],
  },
  {
    categoryID: "software_Driver",
    categoryDescription: "Software Driver download",
    courses: [
      {
        courseName: "Software and Driver download",
        courseID: "SD001",
        description: "Software Driver download",
        categoryID: "software_Driver",
        image:
          "https://i.imgur.com/VbRhuUb.jpeg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "CH340_Driver",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Et31Os9OWVtPtCfXBI7xNLoBDBDwS54WX4Wt-5ygcswKlg?e=lL7kCM",
          },
          {
            topic: "CP2102_Driver",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EjfxawEHArBCse8LybogZuYBnfs-UoHICpjWIeX0JhgZQQ?e=l2oNdW",
          },
          {
            topic: "VS Code & PlatformIO 安裝指引",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Eow01cmp_vVHkCTe4JBEO8ABvdA_6U_q8-CEzAyLk6QPnQ?e=ovTIVo",
          },
          {
            topic: "ICE Studio 安裝指引",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/ErShdo_s2KVClp_6WwsGHiIBKGbJvZRDIA7Ns0ENMhU9EA?e=XqHdBf",
          },

          {
            topic: "HLK Burn Tool",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Eq-jhl9eu3VEqGVUjpgLJicB07r9NYvOqbNLI2cT_n6ZFg?e=GUWpOW",
          },
          {
            topic: "Fusion360 學生認證 & 安裝指引",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EmTkqsQA43NAtB0X4M_pl64ByQr2l3yG-9fSBlqoUxNaag?e=NT1hfd",
          },
          {
            topic: "CoolTerm Serial Debugger",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Esj5CnNYMmxGiqX4mXNEOggBgX3eVNGclWZQJHFruGNqPg?e=l4HfqM",
          },
          {
            topic: "OneNet注冊 & 創建數據源模板",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EkT4AVK3XxdPp3WWDnPD4x0B0GMfYKTFifrLCEg39l5Pxg?e=3BL8fO",
          }
        ],
      },
    ],
  },
  {
    categoryID: "workshop",
    categoryDescription: "ECE Workshop 2023",
    courses: [
      {
        courseName: "ECE Workshop 2023",
        courseID: "WS001",
        description: "ECE Workshop 2023",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "ECE Workshop 2023",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EooUOfgPjb9MsbUX4odaMf8BFbGdk8yJgGJDkUo2oqPrHQ?e=uKTgMf",
          },
        ],
      },

      {
        courseName: "ATS Openday 2023",
        courseID: "WS002",
        description: "ATS Openday 2023",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "ATS Openday 2023",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Es8p0YpEmkZGouEqHfrXT30BP92yKzaZvA4YJCAWaYl9QA?e=YiMUKA",
          },
        ],
      },
      {
        courseName: "PCMS Workshop 2024",
        courseID: "WS003",
        description: "PCMS Workshop 2024",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "PCMS Workshop 2024",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EphaOUJb3JpGi5JZKZgB4yQB913kvarjTLHecHvsYWL2VA?e=jjBRHz",
          },
        ],
      },
      {
        courseName: "HCW Workshop 2024",
        courseID: "HCW001",
        description: "HCW Workshop 2024",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "HCW Workshop 2024",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:b:/g/EbT8TXTmrqlGizm_pf4fCWoBhwV_fnL0FMNxsoYCQiBQRw?e=p2pMrc",
          },
        ],
      },
      {
        courseName: "MCKLN Workshop 2024",
        courseID: "MCKLN001",
        description: "HCW Workshop 2024",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "HCW Workshop 2024",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EuFZbTNROPlFuDlmvI5S2V4BEUaZGn1w7SLHWnrSoG7hHg?e=tnLPqw",
          },
        ],
      },
      {
        courseName: " 跨學科學習-乒乓波掃地機器人",
        courseID: "SBA001",
        description: "跨學科學習-乒乓波掃地機器人",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "Lesson 0",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/PunchCardRDProject/EgcunV58Z2FHhg1WVuDdJckBJu1yItvWeI1sv-gT5aQ1CA?e=pNoOEO",
          },
          {
            topic: "Lesson 1",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/PunchCardRDProject/ElHZL1c81ddHg6yBKQ6kZJsB693QNp0V4PA2x1oEAXMd-g?e=a8AlUE",
          },
          {
            topic: "Lesson 2",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/PunchCardRDProject/EgY6bCBH6KtLtmlYRcMcYQwBGGrmSN5Y2-vHv_1_Ei107Q?e=xDZaNG",
          },
          {
            topic: "Lesson 3 Twist and Odometry",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/PunchCardRDProject/Esbtu3vQS85Jvqjgtl8C9FEBFPxdy5oSnDKRrKESo0LPbQ?e=D3ENPf",
          },
          {
            topic: "Lesson 4 Opencv Ball Detection and Ball Chasing",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/PunchCardRDProject/EqjXhLlaTxZFt-p9e7ph_4wBbpeiHDyvDXoH8jb4xXb4Qw?e=d1rBwu",
          },
          {
            topic: "Lesson 5 報告及3D打印",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/PunchCardRDProject/EvcymC_uD0tBpm0KGHyE-VIBhIbS43_pYhKpRZ7ZuCTeTw?e=iEmaie",
          },
        ],
      },
      {
        courseName: "香港電子科技商會 - IFF 2024 微電子主題工作坊",
        courseID: "HKETAIFF2024",
        description: "香港電子科技商會 - IFF 2024 微電子主題工作坊",
        categoryID: "workshop",
        image:
          "https://scontent.fhkg1-1.fna.fbcdn.net/v/t39.30808-6/327210816_882356836380793_3863020957098899546_n.jpg?_nc_cat=107&ccb=1-7&_nc_sid=cc71e4&_nc_ohc=uOXie3FQ3RoQ7kNvgGOrQRO&_nc_ht=scontent.fhkg1-1.fna&oh=00_AYDU6DjU_gcxVLiZX9N6mwQMoB4YTk6bymmBkSb2MpuJtQ&oe=66EB6DA9",
        downloadUrl:
          "https://stemturnede.sharepoint.com/:f:/g/ErtigeSI-FxAkfe1iU_jZEABsd88VKqn7lCZBKA7IiugJw?e=kDOtaJ",
          resources: [
            {
              topic: "1 - PCB Makers and EasyEDA",
              downloadUrl:
                "https://stemturnede.sharepoint.com/:f:/g/EmIxx8H6YMpCpD5QkqZ01s0BaM-ugoEAMJkn8SlkB4ziyw?e=vHCxNx",
            },
            {
              topic: "2 - Digital Circuit, Chips and Semtron Studio ",
              downloadUrl:
                "https://stemturnede.sharepoint.com/:f:/g/Ekd9BkgYTiNIo7Q1v_LgM0QB4wjwu7JnLtOoS7ly12zLDQ?e=2WsOtm",
            },
          ],
      },
      {
        courseName: "ATS應援棒工作坊",
        courseID: "WS004",
        description: "ATS應援棒工作坊",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "第1章 如何使用EasyEDA",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/msteams_10ec96/EiM9XtxW8oNDqAgjoIiCM2QBrZkStzm20rpEViq7I74Xrw?e=r7GbS3",
          },
          {
            topic: "第2章 使用Fusion360設計3D",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/msteams_10ec96/EjDNMc8rADBEu4Y96GskVt4B7__2t8UY5hFyQyBJYziy5g?e=ud8eRo",
          },
          {
            topic: "第3章 應援棒遠端控制編程",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/msteams_10ec96/EtCPcUQhIUZDpORYbH1cBTcB8A1XEI01D-ldzu12RTAYHg?e=70llvk",
          },
          {
            topic: "第4章 應援棒組裝和測試",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/msteams_10ec96/EtEmy_Pwdb5EggpUtGk1L4YB5nkXQtzw360gsCI9wtJzrA?e=br3gdq",
          },
          {
            topic: "工作坊day1 流水線焊接應援棒",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/msteams_10ec96/EvCuf5Y5CvdKgt-DQe4_7lQB3yB8JvNIjF1huYd1AvRriQ?e=i8jO2M",
          },
          {
            topic: "工作坊day1 應援棒編程設計",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/msteams_10ec96/EveE5nqItzxCicIDviPCEtEBXmt0wQ7cNQi8JFlm9ly2dQ?e=agCPQ5",
          },
          {
            topic: "工作坊day2 流水線燒錄應援棒",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/msteams_10ec96/EtIcvwILfvNChMy1PUe9v5IBCqQwhkvgmXXdT2AD-hjt1g?e=DAT5Fh",
          },
        ],
      },
      {
        courseName: "李宗德蝴蝶園鏡頭配置工作坊",
        courseID: "WS005",
        description: "李宗德蝴蝶園鏡頭配置工作坊",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "第1章 蝴蝶園鏡頭配置",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/s/PunchCardRDProject/EhLFVWHiW9dCnWkbVmY_3s8BeBnoWBvk6BwqyMdqrJqwoQ?e=qAIj03",
          },
        ],
      },
      {
        courseName: "1.5蝴蝶園課程",
        courseID: "WS006",
        description: "1.5蝴蝶園課程",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "教材空間",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/IgCG0X5cv_H0RJP815o9lDdlARrkm7mNMbINSk6SLSGhmJg?e=GXTqUx",
          },
        ],
      },
      {
        courseName: "製作便携發光PCB",
        courseID: "WS007",
        description: "製作便携發光PCB",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "製作便携發光PCB",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EqnpSYXXZylLnX9lVhlDqvMB8L0079lMu_mzguBmW_6SqA?e=Vc9iE9",
          },
        ],
      },
      {
        courseName: "製作NFC金屬探測器",
        courseID: "WS008",
        description: "製作NFC金屬探測器",
        categoryID: "workshop",
        image:
          "https://images.pexels.com/photos/7096/people-woman-coffee-meeting.jpg",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "製作NFC金屬探測器",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/IgDkAhSFDw-2RoX8v1bdgQ0JAWI0xC5YnbhH9-g1oE-j1Dw",
          },
        ],
      },
    ],
  },
  {
    categoryID: "fpga",
    categoryDescription: "透過FPGA領略微電子芯片工程的知識與魅力,對微電子工程師這一職業產生更多認知與理解!有充分的動手機會進行電路設計及編程，成為小小微電子工程師！",
    courses: [
      {
        courseName: "Semtron FPGA 201",
        courseID: "SF201",
        description: "透過FPGA領略微電子芯片工程的知識與魅力,對微電子工程師這一職業產生更多認知與理解!有充分的動手機會進行電路設計及編程，成為小小微電子工程師！",
        categoryID: "fpga",
        image:
          "https://i.imgur.com/vtEaiqi.png",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "Lesson 1 芯片世界Hello World!",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ev8M6jsfocxFjl7Wlpy-D08BaVdtAcmWiNrdKzaKbnGMfw?e=8cMjsJ",
          },
          {
            topic: "Lesson 2 基礎電子數位電路",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ela3a6ffo51Bi5WzYCjFPtgBxhVhJylJEBU70d7WtUylig?e=221frm",
          },

          {
            topic: "Lesson 3 Logic Gates",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EgmOGwqybRNNl-gR7oPcBWEBlUcTPQ_xpSbYFtQWjz3MZg?e=QZApj2",
          },

          {
            topic: "Lesson 4 Boolean Algebra",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EhQKsqg8nYJDgA9xhjIbZ_ABpUgTHrypxyeS7JqZ8d0DaA?e=d8xxZI",
          },

          {
            topic: "Lesson 5 Binary and Hexadecimal",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ejr-1Ewc_YdKpRwcOfOf_ZcBlwS2YzoVsz3ar_lzzxwgEQ?e=NMxn9M",
          },
          {
            topic: "Lesson 6 Signal and Clock",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EhtlQQ0QWJ9FiMYw7YTI_IEBxTNCU-K6cHFSPWrwldvLlA?e=YNacDS",
          },

          {
            topic: "Lesson 7 Flip Flop",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Eg8D_LzC0fhCkcX3PHGZhrMBiPW0etNfonlBIDLld_0bVQ?e=e8OFf4",
          },

          {
            topic: "Lesson 8 MUX",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EvJtUJrSGMBPhs5-80pF3OABDMyev-FjwdrY6XqqQXzfyA?e=1yf0B8",
          },

          {
            topic: "Lesson 9 Bitstream",
            downloadUrl:
              " https://stemturnede.sharepoint.com/:f:/g/EuYe1JNG2xdPn1sU6VbSWgMBbCDm5pQ1kmDm0-6R3jHDjg?e=krk4Iy",
          },

          {
            topic: "Lesson 10 Revision",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/ElLLDJWcjCREudpnQqkezAwBqUDb6tWrsNqjnlcNMz3-Ag?e=lYB1KP",
          },
          {
            topic: "Lesson 11 H-Bridge",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EsYitzKbEkZDotCA22nzjIkBLq1padcwok4Pj07GwgnHOg?e=nccLcR",
          },
          {
            topic: "Lesson 12 Verilog",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/ElrO7SzvhoxMssyqRa3qYgUBx4nmEsS-2Lxtgr6JKUG1Sg?e=M3zw7i",
          },
          {
            topic: "Lesson 13 PWM",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EnjOzkn2i_ZJlkdhHasI-jQBg3EvKf7BbK7pjqMwExKa1w?e=PhZDLY",
          },
          {
            topic: "Lesson 14 Sensor",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ena1GcPZq-hCumb6ldHzjXcB6A7xx9iHqVP-yTpr84LrtA?e=6dco4p",
          },
          {
            topic: "Lesson 15 Line Track Car",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EjPh0_l41s1DpATTeLuqXGIB97VUBPAC5iml1_-EmYk_Vg?e=dsYdLp",
          },
          {
            topic: "Lesson 16 Speech Recognition",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ejhj7S9AjnxFpMD_DZ7IV_MBjm1NP75B7j5KggL7ddpQcQ?e=Bj009F",
          },
          {
            topic: "Lesson 17 Wireless Communication",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Eoe4o1vdaplJsczd1yfbe5ABWx2Gn2kgz8rXT-ZSKArdvQ?e=yse3yD",
          },
          {
            topic: "Lesson 18 Servo Motor",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Eg41lOaJryNLsc0aBBKttocBqLmT3FKNjIuDDPgU_AvyCQ?e=ccEwX3",
          },
          {
            topic: "Lesson 19 FPGA SmartCity Preparation",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EqlInIfCO_9InCRNRr0ThjwBozrwxOxhJQ-tRj38T4VjHA?e=9AzjxI",
          },
          {
            topic: "Lesson 20 FPGA Smart City Exibition",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EkDGMSNZLfFOh0K0Ay8yCgsBIWFXmRia8fbirqOnW6Xlhw?e=ro4vQt",
          },
        ],
      },
      {
        courseName: "AMD X Avnet Certificate Course",
        courseID: "AMD001",
        description: "課程致力於培育未來微電子及芯片人才，旨在讓香港中學生探索電子產品世界，發揮他們在AMD FPGA技術方面的創造力，並將STEM理論付諸實踐。鼓勵參與者利用AMD FPGA技術創建創新的電子產品和系統。通過參與這門課程，學生將學習如何使用AMD FPGA工具和開發平台，深入了解AMD FPGA技術的應用和未來趨勢。",
        categoryID: "fpga",
        image:
          "https://i.imgur.com/RG2ysBq.png",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "Lesson 1 芯片及人工智能應用 - OpenCV 的界面設計教學",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Eo-jTBMDxyRAkhat0c6O68cBZDhgOUKEhZfBSpbvHGovkw?e=23EVpb",
          },
          {
            topic: "Lesson 2 FPGA基礎培訓",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ej0D5N63o1BIoCyFS3CZR7QBLcBJown5OnqxARXPH4un9g?e=R8t6dU",
          },
          {
            topic: "Lesson 3 Ultra96 PYNQ",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EqkpmSXk3nNBuLpXyCIWelQBhUNTjWlnIK7GLz3wH_eavw?e=qKAHiL",
          },
          {
            topic: "Lesson 4 訓練和設計圖像識別AI模型",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ei5MkLd92V9Lnhauc5LnBaMBRDvlnPNMV8lN8ZmljuTPnA?e=QkVaFR",
          },
          {
            topic: "Lesson 5 FPGA的計算機視覺應用",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EsEgzScuFJVNiBA8tSt6KQQBJYKd5K7_avcwFh8WpGt93w?e=XFpeYn",
          },
        ]
      }
    ],
  },
  {
    categoryID: "hardware",
    categoryDescription:
      "無論是顯示器，平板電腦還是智能手機，都是硬件。 我們社會所有現有技術的皆由硬件支撐。 通過物理和電子知識的各種組合，我們可以創造出從日常生活、科學研究、能量采集到硬件加速等任何方面來幫助人類的設備",
    courses: [
      {
        courseName: "印刷電路板入門",
        courseID: "PCB001",
        description:
          "從零開始的印刷電路板設計入門之旅！手把手教程學習如何設計原理圖及佈板。制造属於您的第一塊電板！",
        categoryID: "hardware",
        image:
          "https://i.imgur.com/g6zJVtg_d.webp?maxwidth=1520&fidelity=grand",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "Lesson01 認識EasyEDA",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:b:/g/EUX6RkqsbTNJh0jcvj3IJLMBF-cIp_6MVa3ZavJYlk-1Ag?e=8fG1I0",
          },
          {
            topic: "Lesson02 電路設計101",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EgDY4pRh1cdCrrL7sO5sxnQBe-aWRT8KO9MFDA-3-x2ETg?e=1eTL8m",
          },
          {
            topic: "Lesson03 認識LED閃爍電路",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EshCxudHBVdDuHaimyeds8ABBu4FmWBXHPiRjYAJg3PrSw?e=N1bcuC",
          },
          {
            topic: "Lesson04 如何選擇電池？",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Evc3Qa8hpd9JsKE_7FFFlAEBYbsUwm9jQ8MGyq--pRxzIw?e=kXD1y0",
          },
          {
            topic: "Lesson05 電子復活蛋",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EszJgLxwUFtNh0xwV7Ns2HkBp49usNgtbc3EqsdzUNanCw?e=VMLFU7",
          },
          {
            topic: "Lesson06 設計無綫LED",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Eng6dkrqdzVJklD6A8--CA0BPX8l5kKkZuNB_MyPEdDExg?e=4kxhHA",
          },
          {
            topic: "Lesson 07 如何製作MP3播放器",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EoVn7l6LrOVAv3EUX3dy9NcBtIY6rwR2VfmoIv0u0z-aRw?e=z0fRZw",
          },
          {
            topic: "Lesson 08 如何燒錄語音芯片",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/El2hb725KOJMvCLvhDCiYMEBa9keUEbozXVP_1TuEPQdIQ?e=fCnpIu",
          },
        ],
      },
      {
        courseName: "基礎電子與電路設計",
        courseID: "PCB002",
        description:
          "世上電子元件多不勝數，如何選適合的元件由理解原理及閱讀數據手册開始。透過分析和建立各種電路，成為精明的微電子工程師！",
        categoryID: "hardware",
        image:
          "https://i.imgur.com/bHnry7v_d.webp?maxwidth=1520&fidelity=grand",
        resources: [
          {
            topic: "SMT焊接練習",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EnRHUHQZGMBAgdQyuR8sQm0BE-IjqEVWt5AaXrSVje3dgw?e=3Q8Bni0",
          },
          {
            topic: "脈寬調變與伺服電機",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Eoo-jzOrvcVEuCnweKYAM10BAkErcDF7wpEJ_b-yQCI01g?e=yc1OBQ",
          },
          {
            topic: "PCB作品：個人名片",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EpYEVV0EzS9Fu4r9zwxiQiIBTjfWvC2VyWsjf2agD5Rj3Q?e=Yn6qBL",
          },
          {
            topic: "MP3 播放器",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EtSd0UZPy_tDpmgLMdN8iBQBBUPki_CrC3wanFMl-5ajLQ?e=Q43VE6",
          },
          {
            topic: "NFC 個人名片焊接和設置",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EjHiL4uVIQBEolvhdWWeEeABRfBs_8NiwXwgN5mVWS6_-g?e=sEHNzc",
          },
          {
            topic: "ESP32",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EvgA_tMyWDFJkuQJsW9XkgQBISdGukKLBvT-yPqL0GIGWw?e=vQWWMr",
          },
          {
            topic: "MQTT與傳感器",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EvoHgTfx765KsqEm6R_kgG0Bo3NuUcaoSz1mKOuJM0FQkA?e=nkwidR",
          },
          {
            topic: "ESP32 PCB繪製",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EmE9pMnPe_FFrJAu9WEkYWgBGKE1uR1B150Dyw7hw2mvSQ?e=ezmhP2",
          },
          {
            topic: "數據可視化",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/ElD3X2CUk9FMqDSQ9LkMi4gBawyISnorIcuWmD9SccH2FQ?e=ArZrX6",
          },
        ],
      },
      {
        courseName: "工具/儀器/安全護具教學",
        courseID: "PCB003",
        description:
          "工欲善其事，必先利其器，安全第一。為工程師做任何工作時的兩個首要考慮。如何選正確的工具及用安全方式操作，會在這單元一目了然！",
        categoryID: "hardware",
        image:
          "https://i.imgur.com/FXxenv1_d.webp?maxwidth=1520&fidelity=grand",
        resources: [],
      },

      {
        courseName: "PCB&AI",
        courseID: "PCB004",
        description:
          "設計自己的電路板去整合傳感器AI芯片,通訊模組,並製作3D外殼以建立屬於自己的語音無線遙控器",
        categoryID: "hardware",
        image:
          "https://i.imgur.com/RXXtKo4.png",
        downloadUrl:
          "https://stemturnede.sharepoint.com/sites/info.public.turned-e/Shared%20Documents/Forms/AllItems.aspx?id=%2Fsites%2Finfo%2Epublic%2Eturned-e%2FShared%20Documents%2FCourse&p=true&ga=1",
        resources: [
          {
            topic: "Lesson01 PCB電路設計",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Ek-Okwi_ioNDn80JFuMwm1YB9uX_hHJ1hQejkuBz4ZMS9A?e=KfsEXe",
          },
          {
            topic: "Lesson02 PCB布版設計",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EtVNzsOQmM1OtstEbn__afEBi17YB0J94BqEZzsP87SWog?e=QVJJxq",
          },
          {
            topic: "Lesson03 語音AI",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Engs5lHUN8ZDk0gVbkrehNEBhZMI01qXtIZRiowaaIQ5gg?e=fAzd93",
          },
          {
            topic: "Lesson04 設計思維與3D設計",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EuaQRDpVr_hHntqqamM9NVIBcE-pUXEfssif4cmusAn-bA?e=hmXEif",
          },
          {
            topic: "Lesson05 焊接，組裝，設計(1)",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EgAUlb9KbjZCuIBgLRhVbL0Bw4b5Hzcu0Z0GjZ1kUz2Bgw?e=yLvZAu",
          },
          {
            topic: "Lesson06 焊接，組裝，設計(2)",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EiZ5uDOZHh1AksNWNQk95F8B6FvoP9C8TDxmS5zHpkepqg?e=xrRPqQ",
          },
          {
            topic: "Lesson7 賽前測試",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/EuKPVazogatNiTk_ceZSwrABQ8xKY8AVJmNQXd0V5Jm68Q?e=xieZHR",
          },
          {
            topic: "Lesson8 比賽環節",
            downloadUrl:
              "https://stemturnede.sharepoint.com/:f:/g/Et1kP4cV25xIhhZDtDcY7yEBqTCqAC3g-3PfF3fBeaHkQA?e=rvLfUv",
          },
        ]
      },
      {
        courseName: "NFC個人卡片,設計及焊接",
        courseID: "PCB005",
        description:
          "由電子入門到設計自己的NFC卡片,用生動有趣的方式初次接觸微電子",
        categoryID: "hardware",
        image:
          "https://i.imgur.com/CNSWNHa.png",
        resources: [          
        {
          topic: " NFC卡片設計",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/EpL77KQSRaRMlLigd8kmAw4Bc9KvzYhlg6aslj1NoRNUpg?e=Bbn0xu",
        },],
      },
      {
        courseName: "MP3播放器",
        courseID: "PCB006",
        description:
          "由電子入門到設計自己的MP3播放器,用生動有趣的方式初次接觸微電子",
        categoryID: "hardware",
        image:
          "https://i.imgur.com/CNSWNHa.png",
        resources: [          
        {
          topic: "MP3播放器",
          downloadUrl:
            "https://stemturnede.sharepoint.com/:f:/g/ErmQ3e-njB1Eueg8g7560xcBJyIUbYLn-OrVr562PwqoGg?e=dOQddM",
        },],
      },

    ],
  },
];
